export interface AdminAccessDeniedEventDetail {
  endpoint: string;
  status: number;
  correlationId: string | null;
  requiredPermission: string | null;
  reason: string | null;
  /** The response's public error code, when it sent one (e.g. SPOOF_ACCESS_FORBIDDEN). */
  errorCode?: string;
}

export const ADMIN_ACCESS_DENIED_EVENT = "hc-admin-access-denied";

export const publishAdminAccessDeniedEvent = (
  detail: AdminAccessDeniedEventDetail,
): void => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent<AdminAccessDeniedEventDetail>(ADMIN_ACCESS_DENIED_EVENT, {
      detail,
    }),
  );
};
